export const FALLBACK_STAGES = [[{ id: 'mock-1' }, { id: 'mock-2' }, { id: 'mock-3' }, { id: 'mock-4' }], [{ id: 'mock-1' }, { id: 'mock-2' }], [{ id: 'mock-1' }]]
